import { renderEmptyStateMarkup } from '../emptyStateMarkup';
import { visitorCatalogCtaMarkup } from '../visitorCatalogCta';

/**
 * Browse markup. The topic grid is driven by
 * browseController.refreshBrowseGrid. The skeleton cards live in
 * data-state="loading" and are replaced with real <div
 * class="topic-card"> nodes when the API returns. If the API fails
 * the wrapper falls into data-state="error" and the grid shows a
 * Retry button. There is no prototype-only topic copy in the
 * initial paint.
 */
export const browseMarkup = String.raw`<!-- ====== BROWSE VIEW ====== -->
    <div class="view" id="view-home-browse">
      <h1 class="heading-1" style="margin-bottom:var(--space-16);">Browse Topics</h1>
      <!-- ====== Visitor Browse CTA (round-7) ======
           Sits between the heading and the category pills so the
           visitor sees it before they pick a capsule. Closes the
           "browse has no signup path" blind spot: visitors could
           scroll all 18 cards, click any of them, and only THEN
           hit the visitorGuard -> login modal. With this bar, the
           signup hook is the first thing they see.
           Non-dismissible: no close button (round-8 feedback) so the
           bar always stays visible for visitors. -->
      ${visitorCatalogCtaMarkup('browse')}
      <div class="browse-tools">
        <div class="browse-toolbar-row dmx-list-toolbar">
          <nav class="browse-view-tabs" id="browseFilters" aria-label="Browse views">
            <button type="button" class="browse-view-tab active" data-browse-view="explore" data-proto-click="filterBrowse('all',this)">Explore</button>
            <button type="button" class="browse-view-tab" data-browse-view="recommended" data-proto-click="filterBrowse('recommended',this)">For you</button>
            <button type="button" class="browse-view-tab" data-browse-view="recent" data-proto-click="filterBrowse('recent',this)">Recent</button>
            <button type="button" class="browse-view-tab" data-browse-view="favorites" data-proto-click="filterBrowse('favorites',this)">Saved</button>
          </nav>
          <div class="dmx-toolbar-actions">
            <label class="dmx-toolbar-search" for="browseSearchInput">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>
              <input type="search" inputmode="search" id="browseSearchInput" maxlength="120" autocomplete="off" aria-label="Search topics, keywords" placeholder="Search topics, keywords...">
              <button type="button" id="browseSearchClear" class="dmx-search-clear" aria-label="Clear search" title="Clear" data-proto-click="clearBrowseSearch()" style="display:none;">×</button>
            </label>
            <button type="button" id="browseSearchBtn" class="dmx-search-button" data-proto-click="runBrowseSearch()">Search</button>
          </div>
        </div>
        <div id="browseExploreControls" class="browse-explore-controls">
          <div id="browseCategoryFilters" class="browse-industry-desktop" data-cat-source="topics" role="group" aria-label="Category">
            <button type="button" class="browse-text-filter active" data-browse-category="all" data-proto-click="filterBrowse('all',this)" aria-pressed="true">All</button>
          </div>
          <div class="browse-industry-mobile">
            <button type="button" id="browseIndustryTrigger" aria-label="Category: All categories" aria-haspopup="listbox" aria-expanded="false" aria-controls="browseIndustryMenu"><span id="browseIndustryCurrent">All categories</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg></button>
            <div id="browseIndustryMenu" role="listbox" aria-label="Category" hidden>
              <button type="button" role="option" aria-selected="true" tabindex="0" data-browse-category="all" data-proto-click="filterBrowse('all',this)">All categories</button>
            </div>
          </div>
          <div id="browseSortFilters" class="browse-sort-segments" role="group" aria-label="Sort topics">
            <button type="button" class="active" data-browse-sort="newest" data-proto-click="setBrowseSort('newest',this)" aria-pressed="true">New</button>
            <button type="button" data-browse-sort="trending" data-proto-click="setBrowseSort('trending',this)" aria-pressed="false">Trending</button>
          </div>
        </div>
      </div>
      <div class="topic-grid-wrap" data-state="loading">
        <div class="topic-grid" id="browseGrid">
          <div class="topic-card-compact-skeleton"></div>
          <div class="topic-card-compact-skeleton"></div>
          <div class="topic-card-compact-skeleton"></div>
          <div class="topic-card-compact-skeleton"></div>
          <div class="topic-card-compact-skeleton"></div>
          <div class="topic-card-compact-skeleton"></div>
        </div>
      </div>
      <div id="browseEmpty" style="display:none;">${renderEmptyStateMarkup({ icon: 'bookmark', title: 'No saved topics yet', subtitle: 'Click the bookmark icon on any topic to save it here.' })}</div>
    </div>

    `;
